import { FC } from 'react';
import { Action, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';
import dayjs from 'dayjs';
import { LandscapeDocumentResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-document-response.dto';

export interface LandscapeIndicatorDocumentsOrganismProps {
  data: LandscapeDocumentResponseDto[];
  handleEditAction: (id: string) => void;
  handleDownload: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeIndicatorDocumentsOrganism: FC<
  LandscapeIndicatorDocumentsOrganismProps
> = ({ data, handleEditAction, handleDownload, handleDelete }) => {
  return (
    <SortableTable
      data={data}
      columns={[
        { label: 'Document name', key: 'name' },
        { label: 'File', key: 'file' },
        { label: 'Document Date', key: 'createdOnDateTimeUtc' },
      ]}
      showDownloadButtonHeader={true}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name ?? undefined} />
          <Label content={row.file ?? undefined} />
          <Label
            content={
              dayjs(row.createdOnDateTimeUtc)
                .format('YYYY-MM-DD HH:mm:ss')
                .toString() ?? undefined
            }
          />
          <Action
            type="edit"
            size="sm"
            onClick={() => handleEditAction(row.id)}
          ></Action>
          <Action
            type="download"
            size="sm"
            onClick={() => handleDownload(row.id)}
          ></Action>
          <Action
            type="delete"
            itemName={row.name ?? undefined}
            size="sm"
            onClick={() => handleDelete(row.id)}
          ></Action>
        </TableRow>
      )}
    />
  );
};

export default LandscapeIndicatorDocumentsOrganism;
